import Pantone from '../../../../../../../types/api/pantone'
import { PaintsManufacturer } from '../../../../../../../types/api/print-job-paints'

/** Рецепты пантона по брендам: сначала без версии, затем по возрастанию версии. */
export function groupPantoneVersions(
    pantones: Pantone[],
    name: string,
    manufacturers: PaintsManufacturer[]
): Record<string, Pantone[]> {
    const recipes = pantones
        .filter(pantone => pantone.name === name)
        .sort((a, b) => (a.version ?? 0) - (b.version ?? 0))

    return Object.fromEntries(
        manufacturers.map(item => [
            item.documentId,
            recipes.filter(pantone => pantone.manufacturer?.documentId === item.documentId),
        ])
    )
}
